import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);

export const fetchSchema = () => axios.get('/api/v1/customers/employees/schema/');

export const fetchEmployees = async (params = { page: 1, page_size: 20 }) => {
    const url = '/api/v1/customers/employees/';
    const { results = [], count, next } = await axios.get(url, { params });
    return { results, count, next };
};
export const fetchRoles = async (params = { page: 1, page_size: 100 }) => {
    const url = '/api/v1/customers/employees/roles/';
    const { results = [] } = await axios.get(url, { params });
    return results;
};
export const createEmployees = (data) => {
    return axios.post('/api/v1/customers/employees/create_users/', data);
};
export const updateEmployee = (id, { languages, role }) =>
    axios.patch(`/api/v1/customers/employees/${id}/`, { languages, role });
export const deleteEmployee = (id) => axios.delete(`/api/v1/customers/employees/${id}/`);
export const fetchEmployeesLanguages = () => axios.get('/api/v1/customers/employees/languages/');
